export const BARCODE_SCAN_PATH = 'scan-barcode';
